<template>
	<div class="nav-panel" @click="$emit('click')">
		<div class="icon-container">
			<img :src="icon ?? require('@/assets/transparent.png')" class="icon" />
		</div>
		<div class="text-container">
			<h4 class="title">{{ title }}</h4>
			<p class="subtitle">{{ subtitle }}</p>
		</div>
		<div class="arrow-container">
			<img :src="require('@/assets/arrow-right.png')" alt="Navigate" class="arrow" />
		</div>
		<img v-if="background" :src="background" class="background" />
	</div>
</template>

<script>
export default {
	name: 'MGNavPanel',
	props: {
		title: {
			type: String,
			required: true
		},
		subtitle: {
			type: String,
			required: true
		},
        icon: {
            type: String,
            default: null
        },
		background: { 
			type: String, 
			default: null 
		},
		backgroundColour: {
			type: String,
			default: '#413655'
		}
	},
	emits: ['click']
}
</script>

<style scoped>
.nav-panel {
	display: flex;
	align-items: center;
	background-color: v-bind('backgroundColour');
	border-radius: 12px;
	padding: 16px;
	color: white;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.icon-container {
	margin-right: 16px;
	z-index: 1;
}

.icon {
	width: 40px;
	height: 40px;
}

.text-container {
	flex-grow: 1;
	z-index: 1;
}

.title {
	font-family: 'Gotham-Heavy', sans-serif;
	font-size: 16px;
	margin: 0;
	line-height: 1.2;
}

.subtitle {
	font-size: 14px;
	margin: 0;
}

.arrow-container {
	margin-left: 16px;
	z-index: 1;
}

.arrow {
	width: 15px;
    filter: brightness(0) invert(1);
}

.background {
	position: absolute;
	top: 0;
	left: 0;
	margin-left: 85px;
	width: 100%;
	height: 100%;
	object-fit: cover;
	z-index: 0;
	pointer-events: none;
}

.background-bolt {
	position: absolute;
	height: 150%;
	opacity: 1;
	z-index: 0;
	top: -25%;
}

</style>
